import AccountMainPage from "pages/Account/AccountMainPage";
import EmailInbox from "pages/Email/EmailInbox";
import EmailView from "pages/Email/EmailView";
import ExpenseAddForm from "pages/Expenses/ExpenseAddForm";
import ExpenseDetail from "pages/Expenses/ExpenseDetail";
import ExpensesEdit from "pages/Expenses/ExpenseEditForm";
import Expenses from "pages/Expenses/Expenses";
import InvoiceDetail from "pages/Invoice/InvoiceDetail";
import Invoices from "pages/Invoice/Invoices";
import LoginScreenCustomer from "pages/LoginScreenCustomer";
import CustomerForgotPassword from "pages/CustomerForgotPassword";
import CustomerResetPassword from "pages/CustomerResetPassword";
import PaymentScreen from "pages/PaymentScreen";
import Persons from "pages/Persons/Persons";
import PersonDetail from "pages/Persons/PersonDetail";
import Accounts from "pages/Accounts/Accounts";
import AccountCreate from "pages/Accounts/AccountCreate";
import AccountDetail from "pages/Accounts/AccountDetail";
import Assets from "pages/Assets/Assets";
import AssetDetail from "pages/Assets/AssetDetail";
import AssetForm from "pages/Assets/AssetForm";
import Projects from "pages/Projects/Projects";
import ProjectPayments from "pages/Projects/ProjectPayments";
import ProjectDetail from "pages/Projects/ProjectDetail";
import ProjectCreate from "pages/Projects/ProjectCreate";
import Services from "pages/Services";
import AddServiceForm from "pages/Services/AddServiceForm";
import ServiceDetail from "pages/Services/ServiceDetail";
import Taxes from "pages/Taxes/Taxes";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import Websocket from "websocket/Websocket";
import "./assets/scss/theme.scss";
import AuthProtected from "./components/AuthProtected";
import NonAuthLayout from "./components/NonAuthLayout";
import VerticalLayout from "./components/VerticalLayout";
import Login from "./pages/Authentication/Login";
import AuthEntry from "./pages/AuthEntry";
import AuthReturn from "./pages/AuthReturn";
import Dashboard from "./pages/Dashboard";
import RegisterScreenCustomer from "./pages/RegisterScreenCustomer";
import Tenants from "./pages/Tenants";
import TenantAddForm from "./pages/Tenants/TenantAddForm";
import TenantDetail from "./pages/Tenants/TenantDetail";
import UserProfile from "./pages/User/UserProfile";
import UserProfiles from "./pages/User/UserProfiles";
import UserDetail from "./pages/User/UserDetail";
import UserForm from "./pages/User/UserForm";
import PullToRefresh from "./components/PullToRefresh";
import store from "./store/store";
import accountStore from "./storeAccount/accountStore";
import { useTheme } from "theme";
import { OfficeTranslationProvider } from "i18n/OfficeTranslation";

const ContractTemplateEditor = React.lazy(() => import("pages/Projects/ContractTemplateEditor"));

const routes = [
    {
        path: "/login",
        auth: false,
        component: Login,
        layout: NonAuthLayout
    },
    {
        path: "/",
        auth: true,
        component: Dashboard,
        layout: VerticalLayout
    },
    {
        path: "/tenants",
        auth: true,
        component: Tenants,
        layout: VerticalLayout
    },
    {
        path: "/tenants/add",
        auth: true,
        component: TenantAddForm,
        layout: VerticalLayout
    },
    {
        path: "/tenants/:id",
        auth: true,
        component: TenantDetail,
        layout: VerticalLayout
    },
    {
        path: "/tenants/:id/expenses",
        auth: true,
        component: TenantDetail,
        layout: VerticalLayout
    },
    {
        path: "/tenants/:id/tickets",
        auth: true,
        component: TenantDetail,
        layout: VerticalLayout
    },
    {
        path: "/tenants/:id/customers",
        auth: true,
        component: TenantDetail,
        layout: VerticalLayout
    },
    {
        path: "/profile",
        auth: true,
        component: UserProfile,
        layout: VerticalLayout
    },
    {
        path: "/users",
        auth: true,
        component: UserProfiles,
        layout: VerticalLayout
    },
    {
        path: "/users/add",
        auth: true,
        component: UserForm,
        layout: VerticalLayout
    },
    {
        path: "/users/:id",
        auth: true,
        component: UserDetail,
        layout: VerticalLayout
    },
    {
        path: "/accounts",
        auth: true,
        component: Accounts,
        layout: VerticalLayout
    },
    {
        path: "/accounts/add",
        auth: true,
        component: AccountCreate,
        layout: VerticalLayout
    },
    {
        path: "/accounts/:id",
        auth: true,
        component: AccountDetail,
        layout: VerticalLayout
    },
    {
        path: "/assets",
        auth: true,
        component: Assets,
        layout: VerticalLayout
    },
    {
        path: "/assets/add",
        auth: true,
        component: AssetForm,
        layout: VerticalLayout
    },
    {
        path: "/assets/:id/edit",
        auth: true,
        component: AssetForm,
        layout: VerticalLayout
    },
    {
        path: "/assets/:id",
        auth: true,
        component: AssetDetail,
        layout: VerticalLayout
    },
    {
        path: "/projects",
        auth: true,
        component: Projects,
        layout: VerticalLayout
    },
    {
        path: "/projects/add",
        auth: true,
        component: ProjectCreate,
        layout: VerticalLayout
    },
    {
        path: "/projects/payments",
        auth: true,
        component: ProjectPayments,
        layout: VerticalLayout
    },
    {
        path: "/contract-template",
        auth: true,
        component: ContractTemplateEditor,
        layout: VerticalLayout
    },
    {
        path: "/projects/:id",
        auth: true,
        component: ProjectDetail,
        layout: VerticalLayout
    },
    {
        path: "/customers",
        auth: true,
        component: Accounts,
        layout: VerticalLayout
    },
    {
        path: "/invoices",
        auth: true,
        component: Invoices,
        layout: VerticalLayout
    },
    {
        path: "/invoice/:id",
        auth: true,
        component: InvoiceDetail,
        layout: VerticalLayout
    },
    {
        path: "/customers/add",
        auth: true,
        component: AccountCreate,
        layout: VerticalLayout
    },
    {
        path: "/customers/:id",
        auth: true,
        component: AccountDetail,
        layout: VerticalLayout
    },
    {
        path: "/customers/:id/edit",
        auth: true,
        component: AccountDetail,
        layout: VerticalLayout
    },
    {
        path: "/conversations/:box",
        auth: true,
        component: EmailInbox,
        layout: VerticalLayout
    },
    {
        path: "/conversation/:id",
        auth: true,
        component: EmailView,
        layout: VerticalLayout
    },
    {
        path: "/expenses",
        auth: true,
        component: Expenses,
        layout: VerticalLayout
    },
    {
        path: "/taxes",
        auth: true,
        component: Taxes,
        layout: VerticalLayout
    },
    {
        path: "/expenses/:id",
        auth: true,
        component: ExpenseDetail,
        layout: VerticalLayout
    },
    {
        path: "/expenses/:id/edit",
        auth: true,
        component: ExpensesEdit,
        layout: VerticalLayout
    },
    {
        path: "/tenants/:id/expenses/add",
        auth: true,
        component: ExpenseAddForm,
        layout: VerticalLayout
    },
    {
        path: "/persons",
        auth: true,
        component: Persons,
        layout: VerticalLayout
    },
    {
        path: "/persons/:id",
        auth: true,
        component: PersonDetail,
        layout: VerticalLayout
    },
    {
        path: "/services",
        auth: true,
        component: Services,
        layout: VerticalLayout
    },
    {
        path: "/services/add",
        auth: true,
        component: AddServiceForm,
        layout: VerticalLayout
    },
    {
        path: "/services/:id",
        auth: false,
        component: ServiceDetail,
        layout: VerticalLayout
    },
]

const App: React.FC = () => {
    const theme = useTheme();

    var parts = window.location.hostname.split('.');
    var subdomain = parts.shift();
    const currentHostname = window.location.hostname.toLowerCase();
    const isApplicationHostname = (url: string) => {
        try {
            return new URL(url).hostname.toLowerCase() === currentHostname;
        } catch {
            return false;
        }
    };
    const isAuthApplication = isApplicationHostname(theme.urls.auth);
    const isAccountApplication = isApplicationHostname(theme.urls.account);

    return (<Router>
        {

            (subdomain === "pay" && <Provider store={store}>
                <PullToRefresh />
                <NonAuthLayout>
                    <PaymentScreen />
                </NonAuthLayout>
            </Provider>)

            ||

            (isAuthApplication && <Provider store={store}>
                <PullToRefresh />
                <NonAuthLayout>
                    <Routes>
                        <Route key={"entry"} path={"/entry"} element={<AuthEntry />} />
                        <Route key={"entrypayload"} path={"/entry/:payload"} element={<AuthEntry />} />
                        <Route key={"login"} path={"/login"} element={<LoginScreenCustomer />} />
                        <Route key={"forgot-password"} path={"/forgot-password"} element={<CustomerForgotPassword />} />
                        <Route key={"reset-password"} path={"/reset-password"} element={<CustomerResetPassword />} />
                        <Route key={"register"} path={"/register/*"} element={<RegisterScreenCustomer />} />
                        <Route path="*" element={<Navigate replace to={`/entry`} />} />
                    </Routes>
                </NonAuthLayout>
            </Provider>)

            ||

            (isAccountApplication && <Provider store={accountStore}>
                <PullToRefresh />
                <Websocket />
                <NonAuthLayout>
                    <Routes>
                        <Route key={"auth-return"} path={"/auth-return/:token"}
                            element={<AuthReturn />} />
                        <Route key={"*"} path="*" element={<AccountMainPage />} />
                    </Routes>
                </NonAuthLayout>
            </Provider>)

            ||

            <OfficeTranslationProvider>
                <PullToRefresh />
                <Provider store={store}>
                    <Websocket />
                    <Routes>
                        {routes.map((route: any, index: number) => {
                            return <Route
                                key={index}
                                path={route.path}
                                element={<React.Suspense fallback={null}>{route.auth ?

                                    <AuthProtected>
                                        <>
                                            <route.layout>
                                                <route.component />
                                            </route.layout>
                                        </>
                                    </AuthProtected>

                                    : <>
                                        <route.layout>
                                            <route.component />
                                        </route.layout>
                                    </>
                                }</React.Suspense>} />
                        })}
                        <Route path="*" element={<Navigate replace to={`/login`} />} />
                    </Routes>
                </Provider>
            </OfficeTranslationProvider>}
    </Router>);
};

export default App;
